module.exports = __webpack_public_path__ + "vikatan-icon-18fef6d20de07d3f0117.png";